import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { PhoneSelectFormikField } from '../../../../Phone'
import { PROVIDER_FORM_FIELD_NAME_PHONE } from '../../ProviderForm.constants'

function PhoneField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <PhoneSelectFormikField
      controlProps={{
        borderless: !isMobileScreenSize,
      }}
      fieldComponentProps={{
        label: `${t('Provider.PhoneFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={PROVIDER_FORM_FIELD_NAME_PHONE}
    />
  )
}

export default PhoneField
